var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 13C7.00006 13 8.50006 15 11.0001 15C13.5001 15 15.0001 13 15.0001 13M14.0001 8H14.0101M8.00006 8H8.01006M21.0001 11C21.0001 16.5228 16.5229 21 11.0001 21C5.47721 21 1.00006 16.5228 1.00006 11C1.00006 5.47715 5.47721 1 11.0001 1C16.5229 1 21.0001 5.47715 21.0001 11ZM14.5001 8C14.5001 8.27614 14.2762 8.5 14.0001 8.5C13.7239 8.5 13.5001 8.27614 13.5001 8C13.5001 7.72386 13.7239 7.5 14.0001 7.5C14.2762 7.5 14.5001 7.72386 14.5001 8ZM8.50006 8C8.50006 8.27614 8.2762 8.5 8.00006 8.5C7.72392 8.5 7.50006 8.27614 7.50006 8C7.50006 7.72386 7.72392 7.5 8.00006 7.5C8.2762 7.5 8.50006 7.72386 8.50006 8Z",
    stroke: "#777D80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.e17b7b66b9068a6db9f152c6cdc1ce4f.svg";
export { ForwardRef as ReactComponent };